import React from "react";
import { Modal } from "react-bootstrap";
import classes from "./Logout.module.css";
import Button from "../../components/Button";
import { SlLogout } from "react-icons/sl";
import CommonCard from "../../components/CommonCard";

const LogoutModal = ({ show, setShow, handler }) => {
  return (
    <>
      <style>{`
      .modal-sm {
        --bs-modal-width: 350px;
      }
      .modal-content{
        border-radius: 16px;
      }
    `}</style>
      <Modal
        show={show}
        onHide={setShow}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <CommonCard className={classes["extraCardStyles"]}>
          <div className={classes["heading-wrapper"]}>
            <div className={classes["icon-wrapper"]}>
              <SlLogout size={30} color="#ffff" style={{ marginLeft: -5 }} />
            </div>
            <h1>Logout</h1>
            <p>Are you sure you want to log out from your account?</p>
          </div>
          <div className={classes["action-wrapper"]}>
            <Button
              label="Cancel"
              type="button"
              className={classes["cancel-button"]}
              onClick={setShow}
            />
            <Button
              label="Confirm"
              onClick={handler}
              className={classes["signIn-button"]}
            />
          </div>
        </CommonCard>
      </Modal>
    </>
  );
};

export default LogoutModal;
